export const deepLinkRegexp = /:\/\/+/
